import React from "react";

function PrivacyPolicyPage() {
    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100">
    <div className="bg-white p-8 rounded-lg shadow-lg w-3/4 mt-12">
                <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
                <div className="space-y-4 text-gray-700 text-sm">
                    <p><strong>Privacy Policy for juza.pro</strong></p>
                    <p><strong>Last Updated: May 2025</strong></p>
                    <p>
                        This Privacy Policy explains how juza.pro (&quot;we&quot;, &quot;us&quot;, or &quot;our&quot;) collects, uses, and protects your personal information when you use our website and services (the &quot;Service&quot;).
                    </p>

                    <p><strong>1. Information We Collect</strong><br />
                        We may collect and process the following types of information:
                    </p>
                    <ul className="list-disc list-inside">
                        <li><strong>Account Information:</strong> Name, email address, password, and other information you provide during registration.</li>
                        <li><strong>Event Data:</strong> Information you enter when creating events, guest lists, invitations, or uploading files (e.g., guest names, emails, phone numbers, notes).</li>
                        <li><strong>Payment Data:</strong> Payment details (processed securely via third-party providers; we do not store credit card information).</li>
                        <li><strong>Usage Data:</strong> Information about how you use the Service, including access logs, device information, and cookies.</li>
                    </ul>

                    <p><strong>2. How We Use Your Information</strong></p>
                    <ul className="list-disc list-inside">
                        <li>Provide, operate, and maintain the Service.</li>
                        <li>Manage user accounts, guest lists, and event invitations.</li>
                        <li>Process payments and send invoices if applicable.</li>
                        <li>Communicate with you, including responding to inquiries, support requests, or important updates.</li>
                        <li>Improve our Service, analyze usage, and enhance user experience.</li>
                        <li>Comply with legal obligations.</li>
                    </ul>

                    <p><strong>3. Sharing Your Information</strong></p>
                    <ul className="list-disc list-inside">
                        <li><strong>Service Providers:</strong> Trusted third parties who assist in operating our Service (e.g., hosting, email delivery, payment processing).</li>
                        <li><strong>Event Organizers:</strong> If you are a guest or invitee, your information may be visible to the event organizer.</li>
                        <li><strong>Legal Compliance:</strong> Authorities, if required by law or to protect our rights and users&apos; safety.</li>
                    </ul>
                    <p>We do not sell your personal data to third parties.</p>

                    <p><strong>4. Data Security</strong><br />
                        We take reasonable measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction. However, no internet transmission or storage method is 100% secure.
                    </p>

                    <p><strong>5. Data Retention</strong><br />
                        We retain your data for as long as your account is active or as necessary to provide the Service. You may request deletion of your account or personal information by contacting us.
                    </p>

                    <p><strong>6. Your Rights</strong><br />
                        Depending on your location, you may have the right to:
                    </p>
                    <ul className="list-disc list-inside">
                        <li>Access, update, or correct your personal information.</li>
                        <li>Request deletion of your data (&quot;right to be forgotten&quot;).</li>
                        <li>Object to or restrict processing of your data.</li>
                        <li>Withdraw consent (where processing is based on consent).</li>
                        <li>File a complaint with a data protection authority.</li>
                    </ul>
                    <p>
                        To exercise your rights, contact us at <a href="mailto:support@juza.pro" className="text-blue-500 underline">support@juza.pro</a>.
                    </p>

                    <p><strong>7. Cookies</strong><br />
                        We use cookies and similar technologies to operate the Service and analyze usage. You may manage your cookie preferences via your browser settings.
                    </p>

                    <p><strong>8. International Data Transfers</strong><br />
                        If you use our Service from outside the country where our servers are located, your data may be transferred and processed in other countries.
                    </p>

                    <p><strong>9. Children&apos;s Privacy</strong><br />
                        Our Service is not intended for children under 16. We do not knowingly collect personal information from children. If you believe a child has provided us with personal information, please contact us for removal.
                    </p>

                    <p><strong>10. Changes to This Policy</strong><br />
                        We may update this Privacy Policy from time to time. Updates will be posted on this page with a new &quot;Last Updated&quot; date. We encourage you to review this Policy regularly.
                    </p>

                    <p><strong>11. Contact Us</strong><br />
                        If you have questions or concerns about this Privacy Policy or your personal data, contact us at:<br />
                        <a href="mailto:support@juza.pro" className="text-blue-500 underline">support@juza.pro</a>
                    </p>
                </div>
            </div>
        </div>
    );
}

export default PrivacyPolicyPage;
